import { registerComponent } from '../app'
import { OPEN_CART, CLOSE_CART } from '../events'

const ToggleCart = (scope, el) => {
	const props = {
		openClass: 'open'
	}

	scope.on(OPEN_CART, () => {
		el.classList.add(props.openClass)
	})

	scope.on(CLOSE_CART, () => {
		el.classList.remove(props.openClass)
	})

	el.addEventListener('click', () => {
		el.classList.contains(props.openClass) ? scope.emit(CLOSE_CART) : scope.emit(OPEN_CART)
	})
}

registerComponent('toggle-cart-button', ToggleCart)
